import DOMPurify from 'dompurify'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('safe-html', {
    mounted(el: HTMLElement, binding) {
      // Coerce to a string first — DOMPurify.sanitize drops non-string input (e.g. the
      // number 0), which would otherwise render empty instead of "0". `?? ''` turns
      // null/undefined into an empty string rather than the literal "null"/"undefined".
      el.innerHTML = DOMPurify.sanitize(String(binding.value ?? ''))
    },
    updated(el: HTMLElement, binding) {
      el.innerHTML = DOMPurify.sanitize(String(binding.value ?? ''))
    },
    // On the server DOMPurify has no DOM (no `window`) — its default export is the
    // uninitialized factory without a `.sanitize` method. So SSR-rendered content is
    // NOT sanitized here and must already be trusted; the client `mounted`/`updated`
    // hooks re-sanitize it on hydration.
    getSSRProps(binding) {
      return { innerHTML: String(binding.value ?? '') }
    },
  })
})
